import React, { useState, useEffect, useRef } from 'react';
import FeatherIcon from 'feather-icons-react';
import { Modal, Form, Row, Col, message, Select, Spin } from 'antd';
import PropTypes from 'prop-types';
import { AddUser } from '../style';
import { findAllSegmentByUser, UpdateSegment, FindOnebySegmentId } from "../../../Api/Services/SegmentApiService";
import { BasicFormWrapper } from '../../styled';
import { Button } from '../../../components/buttons/buttons';
import { SegmentIcon } from '../../../components/Icons/Icons';

const { Option } = Select;

// pageFrom: "modal" (default, listing page) | "inline" (query page)
const Popup = ({ sharePopup, setSharePopup, sharingType, sharingIds, PageTypes, setStates, onSuccess, pageFrom, PreviousButton }) => {
    const [form] = Form.useForm();
    const loadingRef = useRef(false);
    const [deleteClick, setDelteClick] = useState(false)
    const [exportData, setExportData] = useState([])
    const [display, setDisplay] = useState(false)
    const [uiReady, setUiReady] = useState(false)

    async function getAllCampaigns() {
        try {
            const response = await findAllSegmentByUser()
            let filteredSegment;
            if (pageFrom !== "inline" && PageTypes !== "Multiple") {
                //  extra filter it by sharingIds 
                filteredSegment = response.sort((a, b) => b.segmentId - a.segmentId).filter((item) => item.segmentType === 'Static' && item.module === sharingType)
            }
            else {
                filteredSegment = response.sort((a, b) => b.segmentId - a.segmentId).filter((item) => item.segmentType === 'Static' && item.module === sharingType)
            }
            const options = filteredSegment.map((option) => (
                <Option value={option.segmentId} key={option.segmentId} label={(
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div className='Div_flex2'>
                            <div className='share_image' title={`${option.segmentName} (${option.module}s)`} style={{ cursor: "default" }}>
                                <span className="image_icon">
                                    {option.segmentName.slice(0, 1).toUpperCase()}
                                </span>
                                <span className='div-ellipsis'>{option.segmentName}</span>
                            </div>
                        </div>
                    </div>)}>
                    <div className='UserList-dropdown' title={`${option.segmentName} (${option.module}s)`}>
                        <div>
                            <span className='details_span_Tag' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                {option.segmentName.slice(0, 1).toUpperCase()}
                            </span>
                        </div>
                        <div>
                            <p style={{ fontWeight: 'bold', margin: 0 }}>{option.segmentName}</p>
                            <p style={{ margin: 0 }}>{`${option.module}s`}</p>
                        </div>
                    </div>
                </Option>
            ));
            setExportData(options)
        } catch (err) {
            setExportData([])
            message.error(err);
        }
    }

    const handleClose = () => {
        setSharePopup(false);
        if (PageTypes === "Multiple") {
            setStates({
                selectedRows: [],
                selectedRowKeys: [],
            })
        }
    }

    async function getCampaignData(id) {
        try {
            const response = await FindOnebySegmentId(id);
            return response;
        } catch (error) {
            message.error(error);
        }
    }

    function updateCampaignIds(campaign, newIds, type) {
        const field = type === "Lead" ? "leads" : "contacts";
        const existingIds = campaign[field] || [];
        const incomingIds = (newIds || []).map((item) => ({
            id: Number(item),
        }));
        const updatedIds = Array.from(
            new Map(
                [...existingIds, ...incomingIds].map((item) => [
                    Number(item.id),
                    { id: Number(item.id) },
                ])
            ).values()
        );
        return { [field]: updatedIds };
    }

    const onSubmit = async (values) => {
        if (loadingRef.current) return;
        loadingRef.current = true;
        setDelteClick(true)
        setDisplay(true)
        let hideMessage;
        const { campaignName } = values;
        const CampainData = await getCampaignData(campaignName)
        const formData = updateCampaignIds(CampainData, sharingIds, sharingType)
        try {
            hideMessage = message.loading("Loading...", 0);
            const response = await UpdateSegment(formData, campaignName)
            if (response.status === 200) {
                message.success(`Selected ${sharingType === "Contact" ? 'contacts' : 'leads'} have been successfully added to the segment`)
                hideMessage();
                setDisplay(false)
                loadingRef.current = false;
                setDelteClick(false)
                if (pageFrom === "inline") {
                    // query page: notify parent to handle success state
                    if (onSuccess) onSuccess();
                } else {
                    // listing page: close modal + reset row selection
                    setSharePopup(false);
                    if (PageTypes === "Multiple") {
                        setStates({
                            selectedRows: [],
                            selectedRowKeys: [],
                        })
                    }
                }
            }
        } catch (error) {
            loadingRef.current = false;
            setDelteClick(false)
            if (hideMessage) hideMessage();
            setDisplay(false)
            message.error(error)
        }
    }

    const onFinishFailed = () => {
        message.error("Please fill out all required fields")
    }

    const fetchAll = async () => {
        await Promise.allSettled([getAllCampaigns()])
        setUiReady(true)
    };

    useEffect(() => {
        fetchAll()
    }, [])

    const campaignSelect = (
        <Select
            style={{ width: '100%' }}
            placeholder="Select segment"
            showSearch
            optionLabelProp="label"
            optionFilterProp="children"
            filterOption={(input, option) => {
                const usernameElement = option.children.props.children[1].props.children[0];
                if (usernameElement && usernameElement.props && usernameElement.props.children) {
                    return String(usernameElement.props.children).toLowerCase().includes(input.toLowerCase());
                }
                return false;
            }}
        >
            {exportData}
        </Select>
    );

    // Inline mode - rendered inside LeadQueryPage "Perform Action" step
    if (pageFrom === "inline") {
        return (
            <AddUser style={{ width: "100%" }}>
                <div className="user-info-form">
                    <BasicFormWrapper>
                        {uiReady ? (
                            <Form style={{ width: '100%' }} form={form} name="CampaignInline" onFinish={onSubmit} onFinishFailed={onFinishFailed} colon={false}>
                                <div style={{ textAlign: "center", fontSize: "larger", fontWeight: "700" }}>Add to Segments</div>
                                <Row gutter={30} style={{ marginBottom: 20, marginTop: 20 }}>
                                    <Col span={4} />
                                    <Col span={16}>
                                        <Form.Item name="campaignName" rules={[{ required: true, message: 'Please select a segment' }]}>
                                            {campaignSelect}
                                        </Form.Item>
                                    </Col>
                                    <Col span={4} />
                                </Row>
                                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", margin: "50px 25px 0px" }}>
                                    <Button size="small" className="gray-button" onClick={() => PreviousButton()}>
                                        <FeatherIcon icon="arrow-left" size={16} />Previous
                                    </Button>
                                    <Button htmlType="submit" className='btn-add_new button_colors' loading={deleteClick} disabled={deleteClick}>
                                        {!deleteClick && <SegmentIcon />}Add to Segments
                                    </Button>
                                </div>
                            </Form>
                        ) : (
                            <div style={{ height: "300px" }} className="spin"><Spin /></div>
                        )}
                    </BasicFormWrapper>
                </div>
            </AddUser>
        );
    }
    return (
        <>
            <Modal
                title="Add to Segments"
                open={sharePopup}
                width={600}
                onCancel={handleClose}
                maskClosable={false}
                footer={uiReady ? [
                    <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 8, whiteSpace: 'nowrap' }}>
                        <Button htmlType="submit" className="gray-button" size="small" onClick={handleClose} disabled={display}>
                            <FeatherIcon icon="x" /> Cancel
                        </Button>
                        <Button size="small" htmlType="submit" className="button_colors" onClick={() => form.submit()} loading={deleteClick} disabled={deleteClick}>
                            {!deleteClick && <SegmentIcon />}Add
                        </Button>
                    </div>
                ] : false}
            >
                {uiReady ? (
                    <AddUser>
                        <div className="user-info-form">
                            <BasicFormWrapper>
                                <Form style={{ width: '100%' }} form={form} name="CampaignModal" onFinish={onSubmit} onFinishFailed={onFinishFailed} colon={false}>
                                    <Row gutter={30} style={{ padding: "0px 20px" }}>
                                        <Col span={24} style={{ margin: "10px 0px" }}>
                                            <Form.Item name="campaignName" id="campaignName" rules={[{ required: true, message: 'Please select a segment' }]}>
                                                {campaignSelect}
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                </Form>
                            </BasicFormWrapper>
                        </div>
                    </AddUser>
                ) : (
                    <div style={{ height: "500px" }} className="spin"><Spin /></div>
                )}
            </Modal>
        </>
    );
};

Popup.propTypes = {
    sharePopup: PropTypes.bool,
    setSharePopup: PropTypes.func,
    sharingType: PropTypes.string.isRequired,
    sharingIds: PropTypes.array.isRequired,
    PageTypes: PropTypes.string,
    setStates: PropTypes.func,
    onSuccess: PropTypes.func,
    pageFrom: PropTypes.string,       // "modal" (default) | "inline"
    PreviousButton: PropTypes.func,   // required when pageFrom="inline"
};

Popup.defaultProps = {
    pageFrom: "modal",
};

export default Popup;
